<template>
  <div id="prop-sharing-box">
    <div class="prop-title">
      <span class="status-tag medium-white-16" :class="isEmpty ? 'status-empty' : 'status-full'">
        <span v-if="isEmpty">ว่าง</span>
        <span v-if="!isEmpty">เต็ม</span>
      </span>
      <div class="prop-name-box medium-white-18">{{ propDetail.name }}</div>
    </div>
    <div class="prop-img">
      <img :src="propertyImage" alt="propertyImage" />
    </div>
    <div class="prop-spec">
      <div class="row no-gutters">
        <div class="prop-spec-item">
          <span class="regular-darkgrey-14">{{ propDetail.restroom }}</span>
          <img class="text-space" src="@/assets/icons/bedroom-icon.svg" />
        </div>
        <div class="prop-spec-item">
          <span class="regular-darkgrey-14">{{ propDetail.bathroom }}</span>
          <img class="text-space" src="@/assets/icons/bathroom-icon.svg" />
        </div>
        <div class="prop-spec-item">
          <span class="regular-darkgrey-14">{{ propDetail.propScale }} ตร.ม.</span>
          <img class="text-space" src="@/assets/icons/area-icon.svg" />
        </div>
        <div class="col-auto mr-auto"></div>
        <div class="prop-spec-item prop-spec-type col-auto">
          <span class="regular-darkgrey-14">{{ propertyType }}</span>
        </div>
      </div>
    </div>
    <div class="prop-invest-table">
      <table class="container">
        <tbody>
          <tr>
            <td>
              <div class="light-14">อัตราค่าเช่าต่อปี</div>
              <div class="regular-bold-24">{{ propDetail.interestPercen }}%</div>
            </td>
            <td>
              <div class="with-border-line"></div>
              <div class="light-14">เรตติ้ง</div>
              <div class="regular-bold-24">
                {{ propDetail.rating }}/
                <span class="regular-bold-16">10</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="light-14">ราคาประเมิน</div>
              <div class="regular-bold-24">
                {{ propPrice }}
                <span class="regular-bold-14">ลบ.</span>
              </div>
            </td>
            <td>
              <div class="with-border-line"></div>
              <div class="light-14">จำนวนผู้ลงทุน</div>
              <div
                class="regular-bold-24"
              >{{investorDetail.numInvestors}}/{{ investorDetail.maxInvestor }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="prop-invest-amt">
      <div class="container">
        <div class="light-14">ราคาขั้นต่ำ</div>
        <div class="regular-bold-24">
          {{ minInvestAmount }}
          <span class="regular-bold-14">บาท</span>
        </div>
        <button class="custom-vs-btn" @click="detailClicked()">
          <span class="medium-14">ข้อมูลเพิ่มเติม</span>
        </button>
      </div>
    </div>
    <div class="prop-detail-btn"></div>
  </div>
</template>

<script>
import { numberWithCommas } from '@/util/numberComma'
import { increaseInvestGroupView } from '@/firebase/firebase-transaction'
export default {
  name: 'PropertySharingBox',
  props: {
    propDetail: Object,
    investor: Object
  },
  computed: {
    propertyType() {
      if (this.propDetail.propType.toUpperCase() === 'CONDOMINIUM') {
        return 'คอนโดมิเนียม'
      } else if (this.propDetail.propType.toUpperCase() === 'HOUSE') {
        return 'บ้าน'
      } else {
        return ''
      }
    },
    isEmpty() {
      if (this.investorDetail.numInvestors >= this.investorDetail.maxInvestor) {
        return false
      } else {
        return true
      }
    },
    propertyImage() {
      const jsonData = JSON.parse(this.propDetail.prop_img)
      return jsonData.prop_img[0].img
    },
    minInvestAmount() {
      return numberWithCommas((this.propDetail.propAmount / this.investorDetail.maxInvestor).toFixed(2))
    },
    propPrice() {
      return (this.propDetail.propAmount / 1000000).toFixed(2)
    }
  },
  data() {
    return {
      btnActive: 0,
      investorDetail: {}
    }
  },
  methods: {
    async detailClicked() {
      this.$router.push({ name: 'JoinInvest', params: { propDetail: this.propDetail } })
      sessionStorage.setItem('propId', this.investorDetail.propID)
      sessionStorage.setItem('investGroupId', Object.keys(this.investor)[0])
      await increaseInvestGroupView(this.investorDetail.propID, Object.keys(this.investor)[0])
    }
  },
  created() {
    this.investorDetail = Object.values(this.investor)[0]
  }
}
</script>

<style scoped>
@import '../styles/PropertyBoxStyle.css';

#prop-sharing-box .status-tag {
  width: 40px;
  height: 25px;
  text-align: center;
  float: right;
}

.status-empty {
  background-color: #91be30;
}

.status-full {
  background-color: #ce3133;
}
</style>
